const SimpleLoader = () => {
  return (
    <div style={styles.container}>
      <style>{`
        @keyframes rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <div style={styles.loader}></div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50vh',
  },
  loader: {
    width: 30,
    height: 30,
    border: '4px solid #791989',
    borderTopColor: 'white',
    borderRadius: '50%',
    animation: 'rotate 1s linear infinite',
  },
};

export default SimpleLoader;
